import { useTranslation } from "react-i18next";

import { Text } from "@krea/shared/design-system/Text";

export const HowWeEstimatedTooltipContent = () => {
  const { t } = useTranslation("loanWidget");
  return (
    <div className="space-y-2">
      <Text className="text-base">
        {t("loanWidget.howWeEstimatedDescription1")}
      </Text>
      <Text className="text-base">
        {t("loanWidget.howWeEstimatedDescription2")}
      </Text>
      <Text className="text-base">
        {t("loanWidget.howWeEstimatedDescription3")}
      </Text>
    </div>
  );
};
